import axios from "axios";
import { baseUrl } from "../config/api-config";

export const createComment = (data, token) => axios.post(`${baseUrl}/comment`, data, {
    headers: {
        authorization: token
    }
})

export const getCommentsByActivity = (activityId, token) => axios.get(`${baseUrl}/comments/${activityId}`, {
    headers: {
        authorization: token
    }
})


